import { conditionalServiceWorkerInstall } from './opus2/util/serviceWorkerRegistration';
const currentURL = window.location.href;
if(currentURL.includes('nblysbx') || currentURL.includes('nblydev') || currentURL.includes('nblytest') || currentURL.includes('localhost')) {
    void (async () => {
        const { default: LocationInterceptor } = await import (/* webpackChunkName: "redirect-guard" */'./opus2/redirect-interceptor/locationInterceptor');
        const locationInterceptor = LocationInterceptor.getInstance();
        locationInterceptor.init();
    })();
}

const runPerformance = false;
if(runPerformance) {
    void (async () => {
        const { initPerformanceMonitoring, monitorLongTasks } = await import(/* webpackChunkName: "monitor-modules" */ './opus2/performance/performanceModule');
        monitorLongTasks();
        initPerformanceMonitoring();
    })();
}

conditionalServiceWorkerInstall();
export * from './opus2/index-legacy';
export * from './global/index-legacy';
